import React from 'react';
import { projectCategories } from '../../data/projects';
import type { CategoryFilter } from '../../utils/projects';
interface ProjectFiltersProps {
  active: CategoryFilter;
  counts: Record<string, number>;
  onChange: (category: CategoryFilter) => void;
}
export function ProjectFilters({
  active,
  counts,
  onChange
}: ProjectFiltersProps) {
  return <div role="group" aria-label="Filter projects by category" className="-mx-5 flex gap-2 overflow-x-auto px-5 pb-1 md:mx-0 md:flex-wrap md:overflow-visible md:px-0" data-id="element-408" data-mp="2nnwkeuzse1pi">
      {projectCategories.map(category => {
      const isActive = active === category.id;
      return <button key={category.id} type="button" aria-pressed={isActive} onClick={() => onChange(category.id)} className={`flex h-11 shrink-0 items-center gap-2 border px-4 font-display text-[15px] font-semibold uppercase tracking-[0.08em] transition-colors duration-150 ${isActive ? 'border-brand-action bg-brand-action text-white' : 'border-white/20 text-steel-200 hover:border-white/60 hover:text-white'}`} data-id="element-409" data-mp="1zuesgjarrta2">
            {category.label}
            <span className={`text-[13px] ${isActive ? 'text-white' : 'text-steel-400'}`} data-id="element-410" data-mp="26jp162s95wwg">{counts[category.id] ?? 0}</span>
          </button>;
    })}
    </div>;
}